import { render, staticRenderFns } from "./BrandingEdit.vue?vue&type=template&id=6366cb38&scoped=true"
import script from "./BrandingEdit.vue?vue&type=script&lang=ts"
export * from "./BrandingEdit.vue?vue&type=script&lang=ts"
import style0 from "./BrandingEdit.vue?vue&type=style&index=0&id=6366cb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366cb38",
  null
  
)

export default component.exports